import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InvoiceStatusEnum } from 'models/enums/invoice-status.enum';
import { PaymentStatusAttributeFilter } from '../../../models/payment-status-attribute-filter';

@Component({
  selector: 'jhi-payment-status-filter',
  templateUrl: './payment-status-filter.component.html',
  styleUrls: ['./payment-status-filter.component.scss'],
})
export class PaymentStatusFilterComponent {
  @Input() filter!: PaymentStatusAttributeFilter;
  @Output() filterChange = new EventEmitter<PaymentStatusAttributeFilter>();
  InvoiceStatus = InvoiceStatusEnum;
}
